export const REACT_SNAP_AGENT = 'ReactSnap';
